// frontend/src/util/assetUrl.ts
export function assetUrl(p?: string) {
  if (!p) return "";

  // Already absolute? use as-is.
  if (/^(https?:)?\/\/|^data:|^blob:/i.test(p)) return p;

  // Frontend public assets (your presets use /images/...): leave as-is.
  if (p.startsWith("/images/") || p.startsWith("/static/")) return p;

  // Normalize env base. Prefer explicit asset base, then API base, then same origin.
  const rawBase =
    (process.env.REACT_APP_ASSET_BASE_URL ||
      process.env.REACT_APP_API_BASE ||
      (typeof window !== "undefined" ? window.location.origin : "")) || "";

  const base = rawBase.replace(/\/+$/, ""); // trim trailing slash(es)

  // Normalize incoming path.
  let path = p.replace(/^\/+/, ""); // trim leading slash(es)

  // If base already ends with /assets and path also starts with assets/, avoid /assets/assets/ duplication.
  const baseEndsWithAssets = /\/assets$/i.test(base);
  const pathStartsWithAssets = /^assets\//i.test(path);
  if (baseEndsWithAssets && pathStartsWithAssets) {
    path = path.replace(/^assets\//i, ""); // drop the extra 'assets/'
  }

  return `${base}/${path}`;
}
